/* esm.sh - applesauce-common@5.2.0/dist/helpers/groups */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/groups.mjs";
